import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  documents: [],
  property: [],
  selectedProperties: [],
  multipleProperties: {
    properties: [],
    totalPages: 1,
  },
  applicationId: null,
  applicationType: '',
  description: '',
  disputeDetail: {
    disputeTypeId: '',
    disputeSubTypeId: '',
    disputeCategoryId: '',
    disputeUserType: '',
  },
  manualAddresses: [],
  manualProperties: [],
  plaintiffs: [],
  defendants: [],
  demands: [],
  plotIds: [],
  disputedProperties: [],
  totalDemandValue: 17000,
  disputeLawFirmsPlaintiff: [],
  disputeLawFirmDefendant: [],
  expertReportFields: {},
  expertWork: [],
  expertReport: [],
  professionalInformation: {},
  expertInformation: {},
};

export default function RequestForExpertOpinion(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REQUEST_FOR_EXPERT_OPINION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.REQUEST_FOR_EXPERT_OPINION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CLEAR_REQUEST_FOR_EXPERT_OPINION_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.FETCH_APPLICATION_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        applicationType: get(action.payload, 'applicationType', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        disputeDetail: get(action.payload, 'disputeDetail', {}),
        disputeLawFirmsPlaintiff: get(action.payload, 'disputeLawFirmsPlaintiff', []),
        disputeLawFirmDefendant: get(action.payload, 'disputeLawFirmDefendant', []),
        plaintiffs: get(action.payload, 'plaintiffs', []),
        defendants: get(action.payload, 'defendants', []),
        plotIds: action?.payload?.application?.disputeProperties?.plotIds || [],
        disputedProperties: action?.payload?.application?.disputeProperties?.properties || [],
        manualProperties: action?.payload?.application?.disputeProperties?.manualProperties,
        demands: get(action.payload, 'demands', []),
        description: get(action.payload, 'description', []),
        expertWork: get(action.payload, 'expertWork', []),
        expertReport: get(action.payload, 'expertReport', []),
        professionalInformation: get(action.payload, 'professionalInformation', {}),
        expertInformation: get(action.payload, 'expertInformation', []),
      };
    case types.FETCH_PROPERTY_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };

    case types.FETCH_DOCUMENTS_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.CHANGE_REQUEST_FOR_EXPERT_OPINION_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.DOWNLOAD_DOCUMENT_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.REQUEST_FOR_EXPERT_OPINION_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_REQUEST_FOR_EXPERT_OPINION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };

    // post flow

    case types.APPROVAL_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.REQUEST_FOR_EXPERT_OPINION_CLEAR_DATA:
      return defaultState;

    case types.DOWNLOAD_TRANSFEER_REQUEST_FOR_EXPERT_OPINION_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_REQUEST_FOR_EXPERT_OPINION_CONTRACT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPLOAD_REQUEST_FOR_EXPERT_OPINION_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.FETCH_REQUEST_FOR_EXPERT_OPINION_PROPERTY_CONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PropertyContractDetails: action.payload,
      };
    case types.UPDATE_EXPERT_REPORTS_FIELDS:
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        expertReportFields:
          Object.keys(action.payload).length === 0
            ? defaultState.expertReportFields
            : {
                ...state.expertReportFields,
                ...action.payload,
              },
      };
    case types.ADD_EXPERT_REPORT:
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        expertReport: [...state.expertReport, action.payload],
      };
    case types.UPDATE_EXPERT_REPORT:
      const existingReports = state.expertReport;
      const indexToUpdate = existingReports.findIndex(item => action.payload.id === item?.id);
      existingReports[indexToUpdate] = action.payload;

      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        expertReportFields: defaultState.expertReportFields,
        expertReport: existingReports,
      };
    case types.DELETE_EXPERT_REPORT:
      const existingReportsArr = state.expertReport;
      const indexToDel = existingReportsArr.findIndex(item => action.payload.id === item?.id);
      existingReportsArr?.splice(indexToDel, 1);
      return {
        ...state,
        loading: false,
        loadingInModal: false,
        errorInModal: null,
        expertReportFields: defaultState.expertReportFields,
        expertReport: existingReportsArr,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.GET_MULTIPLE_PROPERTIES:
      return {
        ...state,
        multipleProperties: {
          ...action.payload,
        },
        loading: false,
      };
    case types.EXPERT_OPINION_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', {}),
      };
    case types.POST_RETURN_REQUEST_FOR_EXPERT_OPINION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
